module.exports = __webpack_public_path__ + "assets/ic_tree05.85371f89.svg";